import { useStaticQuery, graphql } from "gatsby"

const useSitemeta = () => {
  const { site } = useStaticQuery(graphql`
    query SitemetaQuery {
      site {
        siteMetadata {
          favicon
          logos {
            default {
              home
            }
            pharma {
              home
            }
            food {
              home
            }
            environment {
              home
            }
            cosmetics {
              home
            }
            veterinary {
              home
            }
            medical {
              home
            }
            agroChemical {
              home
            }
            lifeScience {
              home
            }
            wasser {
              home
            }
            construction {
              home
            }
            sustainabilityServices {
              home
            }
          }
        }
      }
    }
  `)

  return site
}

export { useSitemeta }
